import * as React from "react";
import cs from "classnames";
import styles from "./placeholder.module.scss";

/**
 * GridSortPlaceholder component
 * @returns {React.ReactElement}
 */
const GridSortPlaceholder: React.FC = React.memo(() => (
  <div className={cs(styles.gridSortBox, "row")}>
    <div className={cs(styles.gridSortResults, "col-xs-12", "col-md-7")}>
      <div className={cs(styles.gridSortResultsText, styles.shimmer)} />
    </div>
    <div className={cs(styles.gridSortFilter, "col-xs-12", "col-md-5")}>
      <div className={cs(styles.gridSortFilterText, styles.shimmer)} />
    </div>
  </div>
));

export default GridSortPlaceholder;

GridSortPlaceholder.displayName = "GridSortPlaceholder";
